// extracted by mini-css-extract-plugin
export default {"iconBtn":"toolbutton_iconBtn__jXxlV"};